import React from "react";
import OcancerzStarFormFun from "./OcancerzStarFormFun";

const OcancerzStarFormList = (props) => {
  return (
    <section
      className="feed"
      style={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0, // CRITICAL: Allows the container to shrink
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <h2
        className="feed-title"
        style={{ fontSize: "1.2rem", margin: "10px 0", color: "#00008b" }}
      >
        Flex Cloud Feed
      </h2>
      {props.postFunction && (
        <OcancerzStarFormFun
          onEditPost={props.onEditPost}
          postFunction={props.postFunction}
          onMergeClick={props.onMergeClick}
          refreshFeed={props.refreshFeed}
        />
      )}
    </section>
  );
};

export default OcancerzStarFormList;
